import { render, staticRenderFns } from "./template.vue?vue&type=template&id=740b5c44"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"
import style0 from "./template.vue?vue&type=style&index=0&id=740b5c44&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('740b5c44')) {
      api.createRecord('740b5c44', component.options)
    } else {
      api.reload('740b5c44', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=740b5c44", function () {
      api.rerender('740b5c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Pygame/template.vue"
export default component.exports